import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearBreaks } from '../../../redux/breaks/breaksSlice';

/**
 * Hook to manage break data for a shift
 *
 * @param {boolean} isNewShift - Whether this is a new shift
 * @param {Object} shift - The shift data
 * @param {string} updatedStatus - Current update status
 */
export const useBreakManagement = (isNewShift, shift, updatedStatus) => {
  const dispatch = useDispatch();

  // Reset breaks on unmount
  useEffect(() => {
    return () => {
      dispatch(clearBreaks());
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
